import { useState, useCallback } from "react";
import moment from "moment";

/**
 * Custom hook for managing offer validation
 * Handles validation errors for offers including time validation
 */
const useOfferValidation = ({
    offersConsolidation,
    setOffersConsolidation,
    selectedDates,
    stationTime
}) => {
    const [showError, setShowError] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");

    const setValidationError = useCallback((offerId, errorMessage, offerError = null) => {
        if (offerId || offerId === "0") {
            let previousOffers = { ...offersConsolidation };
            let currentOffer = { ...offersConsolidation[offerId] };
            currentOffer.error = offerError || errorMessage;
            previousOffers[offerId] = currentOffer;
            setOffersConsolidation(previousOffers);
        }
        setErrorMessage(errorMessage);
        setShowError(true);
    }, [offersConsolidation, setOffersConsolidation]);

    const clearValidationError = useCallback((offerId = null) => {
        if (offerId || offerId === "0") {
            let previousOffers = { ...offersConsolidation };
            let currentOffer = { ...offersConsolidation[offerId] };
            currentOffer.error = false;
            previousOffers[offerId] = currentOffer;
            setOffersConsolidation(previousOffers);
        }
        setShowError(false);
        setErrorMessage("");
    }, [offersConsolidation, setOffersConsolidation]);

    const hasSelectionError = useCallback((offerId) => {
        let currentOffer = { ...offersConsolidation[offerId] };
        const todaySelected = selectedDates.includes(moment(stationTime).format("MM/DD/YYYY"));

        if (offerId || offerId === "0") {
            if (!currentOffer.offerStartTimeHr || !currentOffer.offerStartTimeMin) {
                setValidationError(offerId, "Please select Start Time");
                return true;
            } else if (!currentOffer.offerEndTimeHr || !currentOffer.offerEndTimeMin) {
                setValidationError(offerId, "Please select End Time");
                return true;
            } else {
                if (todaySelected) {
                    const now = stationTime;
                    const minStartTime = moment(now).add(30, 'minutes');
                    const startTime = moment(`${moment(now).format("MM/DD/YYYY")} ${currentOffer.offerStartTimeHr}:${currentOffer.offerStartTimeMin}`, "MM/DD/YYYY HH:mm");
                    if (startTime.isBefore(now)) {
                        setValidationError(offerId, "Start time has already passed for today.");
                        return true;
                    } else if (startTime.isBefore(minStartTime)) {
                        setValidationError(offerId, "Start time should be at least 30 minutes from now.");
                        return true;
                    } else {
                        clearValidationError(offerId);
                        return false;
                    }
                } else {
                    clearValidationError(offerId);
                    return false;
                }
            }
        }
        return false;
    }, [offersConsolidation, selectedDates, stationTime, setValidationError, clearValidationError]);

    return {
        // State
        showError,
        errorMessage,
        setShowError,
        setErrorMessage,
        
        // Functions
        setValidationError,
        clearValidationError,
        hasSelectionError
    };
};

export default useOfferValidation;
